module.exports = __webpack_public_path__ + "img/john.d2c893f5.jpg";